document.addEventListener('DOMContentLoaded', () => {
    $('.hdt-variant-picker .hdt-product-form__values .hdt-product-form_value').html(function(_, html) {
        if (html.includes('(20% OFF)')) {
            return html.replace('(20% OFF)', '(<strong>20% OFF</strong>)');
        } else if (html.includes('(up to 24% OFF)')) {
            return html.replace('(up to 24% OFF)', '(<strong>up to 24% OFF</strong>)');
        } else if (html.includes('(10% OFF)')) {
            return html.replace('(10% OFF)', '(<strong>10% OFF</strong>)');
        } else {
            return html;
        }
    });
});